<template>
  <div
    :style="{ backgroundColor: storeLocation == 0 ? 'black' : 'white' }"
    class="py-4 container-fluid"
  >
    <div v-if="storeLocation != 0" class="row">
      <div
        class="col-sm-12 d-flex justify-content-between align-items-center mb-3"
      >
        <h4 v-if="store_list.length" class="fw-bold">
          {{
            store_list.find((s) => s.id == storeLocation)
              ? store_list.find((s) => s.id == storeLocation).store_name
              : "Selected Store"
          }}
        </h4>

        <div class="d-flex align-items-center">
          <select
            @change="changeStore"
            name="store_id"
            class="form-select form-select-sm me-2"
            style="width: auto; min-width: 200px"
          >
            <option value="0">Select Store...</option>
            <option
              v-for="store in store_list"
              :key="store.id"
              :value="store.id"
              :selected="store.id == storeLocation"
            >
              {{ store.store_name }}
            </option>
          </select>
        </div>
      </div>

      <div
        class="col-sm-12 d-flex justify-content-end flex-wrap mb-3 p-2"
        style="background-color: #f8f9fa; border-radius: 6px"
      >
        <button
          type="button"
          class="btn btn-sm btn-primary compact-btn"
          @click="links('/internal_orders/' + storeLocation)"
        >
          <i class="bi bi-plus-square-dotted"></i> Internal Orders
        </button>

        <!-- <button
          type="button"
          class="btn btn-sm btn-secondary compact-btn"
          data-bs-toggle="modal"
          data-bs-target="#createItemModal"
        >
          <i class="bi bi-plus-square-dotted"></i> Package Requests
        </button> -->

        <button
          type="button"
          style="background-color: bisque"
          class="btn btn-sm compact-btn"
          @click="links('/out_of_stock/' + storeLocation)"
        >
          <i class="bi bi-plus-square-dotted"></i> Out of stock
        </button>

        <button
          type="button"
          style=""
          class="btn btn-danger btn-sm compact-btn"
          @click="links('/expiring')"
        >
          <i class="bi bi-plus-square-dotted"></i> Expiring
        </button>

        <a
          :href="'/item_stock_details/' + storeLocation"
          type="button"
          class="btn btn-sm btn-info text-white compact-btn"
        >
          <i class="bi bi-plus-square-dotted"></i> Batch Breakdown
        </a>

        <a
          :href="'/stock_taking/' + storeLocation"
          class="btn btn-sm btn-success compact-btn"
        >
          <i class="bi bi-plus-square-dotted"></i> Stocks Taking
        </a>

        <button
          type="button"
          class="btn btn-sm btn-dark compact-btn"
          data-bs-toggle="modal"
          data-bs-target="#UploadStockModal"
        >
          <i class="bi bi-plus-circle-dotted"></i> Upload Stock
        </button>

        <button
          type="button"
          class="btn btn-sm btn-outline-primary compact-btn"
          @click="handleOpenModalAddStock"
        >
          <i class="bi bi-plus-lg"></i> Add Stock (Manual)
        </button>
      </div>
    </div>

    <div
      v-else
      :style="{
        height: '60vh',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }"
      class="d-flex"
    >
      <form class="d-flex align-items-start">
        <div class="d-flex flex-column align-items-center me-2">
          <label class="mb-2 text-white fw-bold" style="font-size: 1.5em">
            Select Store To Continue...
          </label>
          <div class="d-flex">
            <select
              style="min-width: 20em"
              @change="changeStore"
              name="store_id"
              class="form-control me-2"
            >
              <option value="0">Select Store...</option>
              <option
                v-for="store in store_list"
                :key="store.id"
                :value="store.id"
                :selected="store.id == storeLocation"
              >
                {{ store.store_name }}
              </option>
            </select>
          </div>
        </div>
      </form>
    </div>

    <StockUploadModal />
    <add_stock_manuallyModal
      v-if="show_add_stock_manually"
      @close-add-stock-manually-modal="close_manual_modal"
    />
  </div>

  <!-- ********************************************************************************** -->
  <BaseLayout
    v-if="storeLocation != 0"
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <!-- <th>#s/n</th> -->
      <th>Item Name</th>
      <th>Class & Category</th>
      <th>Available qty</th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <!-- <td>#{{ user.id }}</td> -->
        <td>
          <h6 class="mb-0 text-sm">
            <itemname
              :ItemName="user.item_name"
              :ItemBrand="user.brand_name"
              :ItemStrength="user.item_strength"
            />
          </h6>
          <p class="text-xs text-secondary mb-0">
            {{ user.class_name }} - {{ user.category_name }}
          </p>
        </td>
        <td>
          <h6 class="mb-0 text-sm">{{ user.class_name }}</h6>
          <p class="text-xs text-secondary mb-0">
            {{ user.category_name }}
          </p>
        </td>
        <td>{{ user.c_quantity }}</td>
      </tr>

      <!--  -->
    </template>
  </BaseLayout>
</template>

<script>
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
// import BaseLayout from "../Patients/components/table_page_layout.vue";
import BaseLayout from "../Patients/components/table_page_layout.vue";
// import formatDateTime from "../../timezone/utc_local_time.js";
import formatDateTime from "../../timezone/utc_local_time";

import { generalApiRequest } from "../../api/apiIndex";
// import Pagination from "../components/pagination.vue";
// import Search from "../components/search.vue";
import Itemname from "./components/ItemName.vue";
// import CreateStockModal from "./modals/add_stock_manuallyModal.vue";
import StockUploadModal from "./modals/stockUpload.vue";
import add_stock_manuallyModal from "./modals/add_stock_manuallyModal.vue";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: `inventory/search_stock_overview/${this.$route.params.storeLocation}`,
      mainUrl: `inventory/get_stock_overview/${this.$route.params.storeLocation}`,
      store_list: [],
      show_add_stock_manually: false,
    };
  },
  components: {
    BaseLayout,
    // Search,
    StockUploadModal,
    Itemname,
    add_stock_manuallyModal,
    // CreateStockModal,
    // Search
  },
  computed: {
    // This computed property ensures `storeLocation` always reflects the current URL
    storeLocation() {
      return this.$route.params.storeLocation;
    },
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
      console.log("*****************************************************");

      console.log(this.users);
    },
    handleOpenModalAddStock() {
      this.show_add_stock_manually = true;
    },
    close_manual_modal() {
      this.show_add_stock_manually = false;
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },

    changeStore(e) {
      const selectedStore = e.target.value;
      // this.$router.push("/item_stock/" + selectedStore);
      window.location.href = "/item_stock/" + selectedStore;
    },
    async get_stores_list() {
      try {
        const url = "inventory/getCompanyItemStores_for_input";
        const store_list = await generalApiRequest(url, "GET", {}, 1);
        this.store_list = store_list.data;
      } catch (error) {
        console.error("Error fetching store list:", error);
      }
    },
    // ✅ Add this new method
    links(path) {
      this.$router.push(path);
    },
  },

  mounted() {
    this.get_stores_list();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
<!-- ==================================================================================================================================== -->
